import {Component, EventEmitter, Output} from '@angular/core';
import {AbstractDialogComponent} from '@wba-ui-module/components/dialogs/abstract-dialog.component';

@Component({
    selector: 'wba-antrag-spaeter-fortsetzen-dialog',
    templateUrl: './antrag-spaeter-fortsetzen-dialog.component.html',
    standalone: false
})
export class AntragSpaeterFortsetzenDialogComponent extends AbstractDialogComponent {
  @Output() commitEvent = new EventEmitter<void>();
}
